import { useEffect, useState } from 'react';
import onboardingClient, { CompanyPreview } from '../client/onboardingClient';

/**
 * The company Robbie already knows for this email's domain (ADR 0008, flow B),
 * fetched once per address while `enabled`. Read only: it creates nothing, and
 * any failure just means no card — sign-up goes on as before.
 */
export const useCompanyPreview = (email: string, enabled: boolean): CompanyPreview | null => {
    const [company, setCompany] = useState<CompanyPreview | null>(null);

    useEffect(() => {
        setCompany(null);
        if (!enabled || !email) return;
        let current = true;
        onboardingClient
            .previewCompany(email)
            .then((found) => { if (current) setCompany(found); })
            .catch(() => undefined);
        return () => { current = false; };
    }, [email, enabled]);

    return company;
};
